module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-08.d7f47ea8.png";